module.exports = __webpack_public_path__ + "static/media/Wiggins-MiddleSchool-HighSchool_Picture.cee50d37.jpg";